<template>
  <div v-if="isShow" class="history_wrapper">
    <h2 class="access_hidden">포인트 내역</h2>
    <div v-if="this.$route.name === 'PointHistory'">
      <point-info a2s="pointHistory"></point-info>
      <point-list></point-list>
    </div>
  </div>
</template>

<script>
import PointInfo from '@/components/modules/common/PointInfo';
import PointList from '@/components/modules/pointHistory/PointList';
import { goToLoginPage, isLogin, setServiceUrl } from '@/utils';

export default {
  components: {
    PointInfo,
    PointList,
  },
  data() {
    return {
      isShow: false,
    };
  },
  created() {
    const { serviceUrl } = this.$route.params;
    if (!serviceUrl) {
      this.$router.push({ path: '/', query: { ...this.$route.query } });
    } else {
      setServiceUrl(serviceUrl);
    }

    if (!isLogin()) {
      goToLoginPage();
    } else {
      this.isShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.history_wrapper {
  padding: 50px 30px 0 30px;
}

@media all and (max-width: 767px) {
  .history_wrapper {
    padding: 30px 15px 0 15px;
  }
}

@media all and (max-width: 480px) {
  .history_wrapper {
    padding: 30px 0 0;
  }
}
</style>
